<template>
  <div v-if="canImpersonate" class="mr-8">
    <v-btn
      v-if="!textFieldActive"
      @click="activateImpersonate"
      :loading="loading"
    >{{$t('Toolbar.virtualAccess')}}</v-btn>
    <v-autocomplete
      v-if="textFieldActive"
      @blur="textFieldActive = false"
      v-model="userSelected"
      :items="items"
      item-text="label"
      item-value="id"
      text
      clearable
      hide-no-data
      hide-details
      label="Usuario"
      solo-inverted
    />
  </div>
</template>

<script>
import {firestore} from '@/plugins/firebase'
import _sortBy from 'lodash/sortBy'

export default {
  data () {
    return {
      textFieldActive: false,
      items: [],
      userSelected: undefined,
      loading: false
    }
  },
  async mounted () {
    if (this.$store.getters.impersonatedUserId) {
      await this.activateImpersonate()
      this.userSelected = this.$store.getters.impersonatedUserId
    }
  },
  computed: {
    canImpersonate () {
      const user = this.$store.getters.user
      return this.$store.getters.impersonatedUserId || (user && user.isAdmin)
    }
  },
  methods: {
    async activateImpersonate () {
      try {
        if (this.items.length === 0) {
          this.loading = true
          const db = await firestore

          const organizations = {}
          const orgsCollection = await db.collection('app/v1/organizations').get()
          orgsCollection.forEach(org => {
            organizations[org.id] = org.data().name
          })

          const users = []
          const usersCollection = await db.collection('app/v1/users').orderBy('organization').get()
          usersCollection.forEach(userDoc => {
            const user = userDoc.data()
            // Skip users without organization (deleted/unlinked users)
            if (!user.organization) {
              return
            }
            const orgId = user.organization.id
            users.push({id: userDoc.id, label: `${organizations[orgId] || orgId}: ${user.name} ${user.lastName || ''} | Email: ${user.email} | Phone: ${user.phone} | ID: ${userDoc.id}`})
          })

          this.items = _sortBy(users, user => user.label.toLowerCase())

        }

        this.textFieldActive = true
      } catch (err) {
        this.$root.snack.show({text: this.$t('UI.serverError'), error: true})
        console.error('IMPERSONATE_ERROR:', err)
      } finally {
        this.loading = false
      }
    },
    impersonate (impersonatedUserId) {
      this.$store.commit('setImpersonatedUserId', impersonatedUserId || null)
      if (!impersonatedUserId) {
        this.$store.commit('setUser', {})
      }
      location.reload()
    }
  },
  watch: {
    userSelected (val) {
      if (val !== this.$store.getters.impersonatedUserId) {
        this.impersonate(val)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ImpersonateBtn.vue?963d05aa